import { useContext } from 'react';

import { ZoomMeetingContext } from '.';

export function useZoomMeetingContext() {
  return useContext(ZoomMeetingContext);
}
